import React from "react";

export const TrashIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#FF6A5F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M3 5.333h13.333M8 8.667v5M11.333 8.667v5M3.833 5.333l.834 10A1.667 1.667 0 0 0 6.333 17H13a1.667 1.667 0 0 0 1.667-1.667l.833-10M7.167 5.333v-2.5A.833.833 0 0 1 8 2h3.333a.833.833 0 0 1 .834.833v2.5"
      ></path>
    </svg>
  );
};
